var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.other)?_c('isogd-doc-in-point',_vm._b({},'isogd-doc-in-point',_vm.doc,false),[_c('template',{slot:"about"},[_c('div',{staticClass:"qwe"})])],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }